export const mediaQuery = {
  small: `@media screen and (max-width: ${700}px)`,
  medium: `@media screen and (max-width: ${1050}px)`,
  large: `@media screen and (max-width: ${1250}px)`
};

export const pageContentPadding = {
  small: 16,
  medium: 32,
  large: 40
};

export const pageContentMaxWidth = 1200;

export const cornerRadius = {
  imageLarge: 80,
  imageMedium: 60,
  imageSmall: 40
};
